// src/components/TrilliAIActionSection.jsx
import React from "react";
import {
  Brain,
  ShieldCheck,
  Zap,
  ShoppingCart,
  Globe,
  Clock,
} from "lucide-react";

const trilliActions = [
  {
    icon: Brain,
    title: "Real-Time Intelligent Assistance",
    desc: "Trilli guides every user instantly with contextual AI support across roles, products, and decisions.",
  },
  {
    icon: ShieldCheck,
    title: "Scam-Free & Verified Network",
    desc: "Advanced AI verification ensures trusted identities, real professionals, and zero fake profiles.",
  },
  {
    icon: Zap,
    title: "Instant Professional Matching",
    desc: "Trilli intelligently matches users with the most relevant verified experts, services, and opportunities.",
  },
  {
    icon: ShoppingCart,
    title: "AI-Powered Sales & Onboarding",
    desc: "Automated sales flows, lead qualification, onboarding, and support—powered by Trilli AI.",
  },
  {
    icon: Globe,
    title: "Works Across All Markets",
    desc: "From traders to institutions, Trilli operates seamlessly across 24+ global markets and ecosystems.",
  },
  {
    icon: Clock,
    title: "24/7 Market Companion",
    desc: "A continuous AI companion that never sleeps—supporting users at every step of their journey.",
  },
];

export default function TrilliAIActionSection() {
  return (
    <section className="w-full bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-6">
        {/* HEADER */}
        <div className="mb-14 max-w-3xl">
          <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
            Experience <span className="text-blue-600">Trilli AI</span> in
            Action
          </h2>
          <p className="mt-1 text-sm text-gray-400 sm:text-base">
            Experience how Trilli AI powers verification, guidance, automation,
            and intelligent matching across the Million2Trillion ecosystem.
          </p>
        </div>

        {/* DARK CONTAINER */}
        <div className="rounded-3xl bg-[#0B0F19] px-6 py-14 shadow-[0_40px_120px_rgba(0,0,0,0.6)] md:px-12">
          {/* ⬇️ KEY FIX: items-stretch */}
          <div className="grid grid-cols-1 items-stretch gap-8 lg:grid-cols-3">
            {/* LEFT: ACTION CARDS */}
            <div className="grid h-full grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-2">
              {trilliActions.map((item) => {
                const Icon = item.icon;

                return (
                  <div
                    key={item.title}
                    className="rounded-2xl border border-white/10 bg-gradient-to-br from-[#12172A] to-[#0B0F19] p-6 transition-all duration-300 hover:-translate-y-2 hover:border-blue-500/40 hover:shadow-[0_0_40px_rgba(59,130,246,0.25)]"
                  >
                    <div className="mb-3 flex items-center gap-3">
                      <div className="flex h-9 w-9 items-center justify-center rounded-lg border border-blue-400/20 bg-blue-500/10">
                        <Icon className="h-4.5 w-4.5 text-blue-400" />
                      </div>

                      <h3 className="text-lg font-semibold text-white">
                        {item.title}
                      </h3>
                    </div>

                    <p className="text-sm leading-relaxed text-white/70">
                      {item.desc}
                    </p>
                  </div>
                );
              })}
            </div>

            {/* RIGHT: TRILLI IMAGE (SAME HEIGHT AS LEFT) */}
            <div className="relative flex h-full items-center justify-center">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/Trilli%2Ftrilli-sideview.jpg?alt=media&token=cde01aac-9695-40ab-89af-952998f79396"
                alt="Trilli AI"
                className="h-full w-full rounded-2xl border border-white/10 object-cover"
              />

              {/* Glow */}
              <div className="absolute inset-0 -z-10 rounded-full bg-blue-500/20 blur-[120px]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
